// source: no/jotta/openapi/file/file.v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_ping_pb = require('../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var no_jotta_openapi_job_v1_job_v1_pb = require('../../../../no/jotta/openapi/job/v1/job.v1_pb.js');
goog.object.extend(proto, no_jotta_openapi_job_v1_job_v1_pb);
var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.AllocateConflictHandler', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.AllocateRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.AllocateResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.ErrorCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CopyRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CopyRequest.ConflictHandler', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CopyResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CopyResponse.CopyError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.ErrorCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CopyResponse.ResultCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CreateFolderRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CreateFolderResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.CreateFolderResponse.CreateFolderError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.DeleteRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.DeleteResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.DownloadZipRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.DownloadZipResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.FileRevision', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.FileState', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.FileSystemError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.FormParameter', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.GetPathRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.GetPathRequest.Sort', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.GetPathResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.InvalidPathError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.Item', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.Item.ItemCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ItemAction', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ItemKind', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ItemType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListFolderItemResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.ResultCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListFolderRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListFolderResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListFolderStats', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListFolderStreamRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListRevisionsRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.ListRevisionsResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.MoveRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.MoveRequest.ConflictHandler', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.MoveResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.MoveResponse.MoveError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.ErrorCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.MoveResponse.ResultCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.PathItem', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.RecentFilesRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.RecentFilesResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.RestoreRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.RestoreResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.RetryAfterError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.SearchRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.SearchResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.SimpleFile', null, global);
goog.exportSymbol('proto.no.jotta.openapi.file.v2.SimpleFolder', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.PathItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.PathItem.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.PathItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.PathItem.displayName = 'proto.no.jotta.openapi.file.v2.PathItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.FormParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.FormParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.FormParameter.displayName = 'proto.no.jotta.openapi.file.v2.FormParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.DownloadZipResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.DownloadZipResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.DownloadZipResponse.displayName = 'proto.no.jotta.openapi.file.v2.DownloadZipResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.DownloadZipRequest.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.DownloadZipRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.DownloadZipRequest.displayName = 'proto.no.jotta.openapi.file.v2.DownloadZipRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.FileRevision = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.FileRevision, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.FileRevision.displayName = 'proto.no.jotta.openapi.file.v2.FileRevision';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.RetryAfterError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.RetryAfterError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.RetryAfterError.displayName = 'proto.no.jotta.openapi.file.v2.RetryAfterError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.InvalidPathError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.InvalidPathError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.InvalidPathError.displayName = 'proto.no.jotta.openapi.file.v2.InvalidPathError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.GetPathRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.GetPathRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.GetPathRequest.displayName = 'proto.no.jotta.openapi.file.v2.GetPathRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.GetPathResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.GetPathResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.GetPathResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.GetPathResponse.displayName = 'proto.no.jotta.openapi.file.v2.GetPathResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.AllocateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.AllocateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.AllocateRequest.displayName = 'proto.no.jotta.openapi.file.v2.AllocateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.AllocateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.AllocateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.AllocateResponse.displayName = 'proto.no.jotta.openapi.file.v2.AllocateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.displayName = 'proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.SearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.SearchRequest.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.SearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.SearchRequest.displayName = 'proto.no.jotta.openapi.file.v2.SearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.SearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.SearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.SearchResponse.displayName = 'proto.no.jotta.openapi.file.v2.SearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.CreateFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.CreateFolderRequest.displayName = 'proto.no.jotta.openapi.file.v2.CreateFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.CreateFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.CreateFolderResponse.displayName = 'proto.no.jotta.openapi.file.v2.CreateFolderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.MoveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.MoveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.MoveRequest.displayName = 'proto.no.jotta.openapi.file.v2.MoveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.MoveResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.file.v2.MoveResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.file.v2.MoveResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.MoveResponse.displayName = 'proto.no.jotta.openapi.file.v2.MoveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.displayName = 'proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.CopyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.CopyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.CopyRequest.displayName = 'proto.no.jotta.openapi.file.v2.CopyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.CopyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.file.v2.CopyResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.file.v2.CopyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.CopyResponse.displayName = 'proto.no.jotta.openapi.file.v2.CopyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.displayName = 'proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.DeleteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.DeleteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.DeleteRequest.displayName = 'proto.no.jotta.openapi.file.v2.DeleteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.DeleteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.DeleteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.DeleteResponse.displayName = 'proto.no.jotta.openapi.file.v2.DeleteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.RestoreRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.RestoreRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.RestoreRequest.displayName = 'proto.no.jotta.openapi.file.v2.RestoreRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.RestoreResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.RestoreResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.RestoreResponse.displayName = 'proto.no.jotta.openapi.file.v2.RestoreResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.displayName = 'proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.displayName = 'proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListRevisionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListRevisionsRequest.displayName = 'proto.no.jotta.openapi.file.v2.ListRevisionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.ListRevisionsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListRevisionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListRevisionsResponse.displayName = 'proto.no.jotta.openapi.file.v2.ListRevisionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.SimpleFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.SimpleFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.SimpleFile.displayName = 'proto.no.jotta.openapi.file.v2.SimpleFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.file.v2.Item.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.file.v2.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.Item.displayName = 'proto.no.jotta.openapi.file.v2.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.SimpleFolder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.SimpleFolder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.SimpleFolder.displayName = 'proto.no.jotta.openapi.file.v2.SimpleFolder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListFolderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListFolderRequest.displayName = 'proto.no.jotta.openapi.file.v2.ListFolderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.ListFolderResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListFolderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListFolderResponse.displayName = 'proto.no.jotta.openapi.file.v2.ListFolderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListFolderItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListFolderItemResponse.displayName = 'proto.no.jotta.openapi.file.v2.ListFolderItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListFolderStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListFolderStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListFolderStats.displayName = 'proto.no.jotta.openapi.file.v2.ListFolderStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.displayName = 'proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.ListFolderStreamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.displayName = 'proto.no.jotta.openapi.file.v2.ListFolderStreamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.RecentFilesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.RecentFilesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.RecentFilesRequest.displayName = 'proto.no.jotta.openapi.file.v2.RecentFilesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.file.v2.RecentFilesResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.file.v2.RecentFilesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.file.v2.RecentFilesResponse.displayName = 'proto.no.jotta.openapi.file.v2.RecentFilesResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.PathItem.repeatedFields_ = [13,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.PathItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.PathItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.PathItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    kind: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    downloadLink: jspb.Message.getFieldWithDefault(msg, 6, ""),
    size: jspb.Message.getFieldWithDefault(msg, 7, 0),
    checksum: jspb.Message.getFieldWithDefault(msg, 8, ""),
    createdAtMillis: jspb.Message.getFieldWithDefault(msg, 9, 0),
    modifiedAtMillis: jspb.Message.getFieldWithDefault(msg, 10, 0),
    deletedAtMillis: jspb.Message.getFieldWithDefault(msg, 11, 0),
    mime: jspb.Message.getFieldWithDefault(msg, 12, ""),
    childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.no.jotta.openapi.file.v2.PathItem.toObject, includeInstance),
    publicLinkId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    actionList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
    thumbLink: jspb.Message.getFieldWithDefault(msg, 16, ""),
    commentItemId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    commentAuthToken: jspb.Message.getFieldWithDefault(msg, 18, ""),
    owner: jspb.Message.getFieldWithDefault(msg, 19, ""),
    folderShareId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 21, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.PathItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.PathItem;
  return proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.PathItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.ItemKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 4:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.ItemType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadLink(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAtMillis(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setModifiedAtMillis(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeletedAtMillis(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 13:
      var value = new proto.no.jotta.openapi.file.v2.PathItem;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicLinkId(value);
      break;
    case 15:
      var values = /** @type {!Array<!proto.no.jotta.openapi.file.v2.ItemAction>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAction(values[i]);
      }
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbLink(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentItemId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentAuthToken(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwner(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderShareId(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.PathItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getDownloadLink();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getModifiedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getDeletedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter
    );
  }
  f = message.getPublicLinkId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getActionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      15,
      f
    );
  }
  f = message.getThumbLink();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCommentItemId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCommentAuthToken();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOwner();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getFolderShareId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ItemKind kind = 3;
 * @return {!proto.no.jotta.openapi.file.v2.ItemKind}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getKind = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.ItemKind} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.ItemKind} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ItemType type = 4;
 * @return {!proto.no.jotta.openapi.file.v2.ItemType}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getType = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.ItemType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.ItemType} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string download_link = 6;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getDownloadLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setDownloadLink = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 size = 7;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string checksum = 8;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 created_at_millis = 9;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getCreatedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setCreatedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 modified_at_millis = 10;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getModifiedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setModifiedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 deleted_at_millis = 11;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getDeletedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setDeletedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string mime = 12;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated PathItem children = 13;
 * @return {!Array<!proto.no.jotta.openapi.file.v2.PathItem>}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.file.v2.PathItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.file.v2.PathItem, 13));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.file.v2.PathItem>} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
*/
proto.no.jotta.openapi.file.v2.PathItem.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.PathItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.no.jotta.openapi.file.v2.PathItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};


/**
 * optional string public_link_id = 14;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getPublicLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setPublicLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * repeated ItemAction action = 15;
 * @return {!Array<!proto.no.jotta.openapi.file.v2.ItemAction>}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getActionList = function() {
  return /** @type {!Array<!proto.no.jotta.openapi.file.v2.ItemAction>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.file.v2.ItemAction>} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setActionList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.ItemAction} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.addAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.clearActionList = function() {
  return this.setActionList([]);
};


/**
 * optional string thumb_link = 16;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getThumbLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setThumbLink = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string comment_item_id = 17;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getCommentItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setCommentItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string comment_auth_token = 18;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getCommentAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setCommentAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string owner = 19;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string folder_share_id = 20;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getFolderShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setFolderShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string encoded_content_ref = 21;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string content_id = 22;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.PathItem} returns this
 */
proto.no.jotta.openapi.file.v2.PathItem.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.FormParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.FormParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.FormParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.FormParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.FormParameter}
 */
proto.no.jotta.openapi.file.v2.FormParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.FormParameter;
  return proto.no.jotta.openapi.file.v2.FormParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.FormParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.FormParameter}
 */
proto.no.jotta.openapi.file.v2.FormParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.FormParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.FormParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.FormParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.FormParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.FormParameter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.FormParameter} returns this
 */
proto.no.jotta.openapi.file.v2.FormParameter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.FormParameter.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.FormParameter} returns this
 */
proto.no.jotta.openapi.file.v2.FormParameter.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.DownloadZipResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    method: jspb.Message.getFieldWithDefault(msg, 2, ""),
    body: jspb.Message.getFieldWithDefault(msg, 3, ""),
    parameterList: jspb.Message.toObjectList(msg.getParameterList(),
    proto.no.jotta.openapi.file.v2.FormParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipResponse}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.DownloadZipResponse;
  return proto.no.jotta.openapi.file.v2.DownloadZipResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipResponse}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.file.v2.FormParameter;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.FormParameter.deserializeBinaryFromReader);
      msg.addParameter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.DownloadZipResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getParameterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.no.jotta.openapi.file.v2.FormParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} returns this
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string method = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} returns this
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} returns this
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated FormParameter parameter = 4;
 * @return {!Array<!proto.no.jotta.openapi.file.v2.FormParameter>}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.getParameterList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.file.v2.FormParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.file.v2.FormParameter, 4));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.file.v2.FormParameter>} value
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} returns this
*/
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.setParameterList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.FormParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.FormParameter}
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.addParameter = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.no.jotta.openapi.file.v2.FormParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipResponse} returns this
 */
proto.no.jotta.openapi.file.v2.DownloadZipResponse.prototype.clearParameterList = function() {
  return this.setParameterList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.DownloadZipRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipRequest}
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.DownloadZipRequest;
  return proto.no.jotta.openapi.file.v2.DownloadZipRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipRequest}
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.DownloadZipRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string path = 1;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.prototype.getPathList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} returns this
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.prototype.setPathList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} returns this
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.prototype.addPath = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} returns this
 */
proto.no.jotta.openapi.file.v2.DownloadZipRequest.prototype.clearPathList = function() {
  return this.setPathList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.FileRevision.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.FileRevision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.FileRevision.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    size: jspb.Message.getFieldWithDefault(msg, 3, 0),
    checksum: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdAtMillis: jspb.Message.getFieldWithDefault(msg, 5, 0),
    modifiedAtMillis: jspb.Message.getFieldWithDefault(msg, 6, 0),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision}
 */
proto.no.jotta.openapi.file.v2.FileRevision.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.FileRevision;
  return proto.no.jotta.openapi.file.v2.FileRevision.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.FileRevision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision}
 */
proto.no.jotta.openapi.file.v2.FileRevision.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAtMillis(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setModifiedAtMillis(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.FileRevision.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.FileRevision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.FileRevision.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getModifiedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision} returns this
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision} returns this
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 size = 3;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision} returns this
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string checksum = 4;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision} returns this
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 created_at_millis = 5;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.getCreatedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision} returns this
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.setCreatedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 modified_at_millis = 6;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.getModifiedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision} returns this
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.setModifiedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string encoded_content_ref = 7;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision} returns this
 */
proto.no.jotta.openapi.file.v2.FileRevision.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.RetryAfterError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.RetryAfterError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.toObject = function(includeInstance, msg) {
  var f, obj = {
    retryAfterMillis: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.RetryAfterError}
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.RetryAfterError;
  return proto.no.jotta.openapi.file.v2.RetryAfterError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.RetryAfterError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.RetryAfterError}
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRetryAfterMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.RetryAfterError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.RetryAfterError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRetryAfterMillis();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 retry_after_millis = 1;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.prototype.getRetryAfterMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.RetryAfterError} returns this
 */
proto.no.jotta.openapi.file.v2.RetryAfterError.prototype.setRetryAfterMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.InvalidPathError.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.InvalidPathError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.InvalidPathError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.InvalidPathError.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.InvalidPathError}
 */
proto.no.jotta.openapi.file.v2.InvalidPathError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.InvalidPathError;
  return proto.no.jotta.openapi.file.v2.InvalidPathError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.InvalidPathError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.InvalidPathError}
 */
proto.no.jotta.openapi.file.v2.InvalidPathError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.InvalidPathError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.InvalidPathError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.InvalidPathError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.InvalidPathError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.GetPathRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sort: jspb.Message.getFieldWithDefault(msg, 2, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    includeChildren: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    includeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    cursor: jspb.Message.getFieldWithDefault(msg, 6, ""),
    includeChildrenCursors: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    includeThumb: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.GetPathRequest;
  return proto.no.jotta.openapi.file.v2.GetPathRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort} */ (reader.readEnum());
      msg.setSort(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeChildren(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDeleted(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeChildrenCursors(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeThumb(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.GetPathRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSort();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getIncludeChildren();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIncludeDeleted();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIncludeChildrenCursors();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIncludeThumb();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.Sort = {
  UNKNOWN: 0,
  NAME_ASC: 1,
  NAME_DESC: 2,
  DATE_ASC: 3,
  DATE_DESC: 4,
  SIZE_ASC: 5,
  SIZE_DESC: 6
};

/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Sort sort = 2;
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getSort = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest.Sort} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setSort = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 limit = 3;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool include_children = 4;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getIncludeChildren = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setIncludeChildren = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool include_deleted = 5;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getIncludeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setIncludeDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string cursor = 6;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool include_children_cursors = 8;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getIncludeChildrenCursors = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setIncludeChildrenCursors = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool include_thumb = 7;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.getIncludeThumb = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathRequest} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathRequest.prototype.setIncludeThumb = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.GetPathResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.GetPathResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathItem: (f = msg.getPathItem()) && proto.no.jotta.openapi.file.v2.PathItem.toObject(includeInstance, f),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    childCursorList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.GetPathResponse;
  return proto.no.jotta.openapi.file.v2.GetPathResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.GetPathResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.PathItem;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader);
      msg.setPathItem(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addChildCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.GetPathResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.GetPathResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChildCursorList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional PathItem path_item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.getPathItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse} returns this
*/
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.setPathItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.clearPathItem = function() {
  return this.setPathItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.hasPathItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string cursor = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string child_cursor = 3;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.getChildCursorList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.setChildCursorList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.addChildCursor = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.GetPathResponse} returns this
 */
proto.no.jotta.openapi.file.v2.GetPathResponse.prototype.clearChildCursorList = function() {
  return this.setChildCursorList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.AllocateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.AllocateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    md5: jspb.Message.getFieldWithDefault(msg, 2, ""),
    size: jspb.Message.getFieldWithDefault(msg, 3, 0),
    createdAtMillis: jspb.Message.getFieldWithDefault(msg, 4, 0),
    modifiedAtMillis: jspb.Message.getFieldWithDefault(msg, 5, 0),
    conflictHandler: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.AllocateRequest;
  return proto.no.jotta.openapi.file.v2.AllocateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.AllocateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAtMillis(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setModifiedAtMillis(value);
      break;
    case 6:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.AllocateConflictHandler} */ (reader.readEnum());
      msg.setConflictHandler(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.AllocateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.AllocateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getModifiedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getConflictHandler();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string md5 = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 size = 3;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_at_millis = 4;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.getCreatedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.setCreatedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 modified_at_millis = 5;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.getModifiedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.setModifiedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional AllocateConflictHandler conflict_handler = 6;
 * @return {!proto.no.jotta.openapi.file.v2.AllocateConflictHandler}
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.getConflictHandler = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.AllocateConflictHandler} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.AllocateConflictHandler} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateRequest} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateRequest.prototype.setConflictHandler = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.AllocateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.AllocateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    path: jspb.Message.getFieldWithDefault(msg, 2, ""),
    state: jspb.Message.getFieldWithDefault(msg, 3, 0),
    uploadId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    uploadUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    bytes: jspb.Message.getFieldWithDefault(msg, 6, 0),
    resumePosition: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.AllocateResponse;
  return proto.no.jotta.openapi.file.v2.AllocateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.AllocateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.FileState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadUrl(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBytes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResumePosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.AllocateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.AllocateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUploadId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUploadUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBytes();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getResumePosition();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateError = {
  UNKNOWN: 0,
  ALLOCATE_FILE_ONTO_FOLDER: 1,
  ALLOCATE_FILE_ONTO_FILE: 2,
  ALLOCATE_INVALID_DESTINATION: 3,
  ALLOCATE_FILE_WITH_ILLEGAL_CONTENT: 4
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.ErrorCase = {
  ERROR_NOT_SET: 0,
  ALLOCATE_ERROR: 1,
  FILE_SYSTEM_ERROR: 2,
  RETRY_AFTER_ERROR: 3,
  INVALID_PATH_ERROR: 4
};

/**
 * @return {proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.ErrorCase}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.getErrorCase = function() {
  return /** @type {proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.ErrorCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    allocateError: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fileSystemError: jspb.Message.getFieldWithDefault(msg, 2, 0),
    retryAfterError: (f = msg.getRetryAfterError()) && proto.no.jotta.openapi.file.v2.RetryAfterError.toObject(includeInstance, f),
    invalidPathError: (f = msg.getInvalidPathError()) && proto.no.jotta.openapi.file.v2.InvalidPathError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage;
  return proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateError} */ (reader.readEnum());
      msg.setAllocateError(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (reader.readEnum());
      msg.setFileSystemError(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.file.v2.RetryAfterError;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.RetryAfterError.deserializeBinaryFromReader);
      msg.setRetryAfterError(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.file.v2.InvalidPathError;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.InvalidPathError.deserializeBinaryFromReader);
      msg.setInvalidPathError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateError} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRetryAfterError();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.file.v2.RetryAfterError.serializeBinaryToWriter
    );
  }
  f = message.getInvalidPathError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.no.jotta.openapi.file.v2.InvalidPathError.serializeBinaryToWriter
    );
  }
};


/**
 * optional AllocateError allocate_error = 1;
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateError}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.getAllocateError = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateError} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateError} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.setAllocateError = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.clearAllocateError = function() {
  return jspb.Message.setOneofField(this, 1, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.hasAllocateError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileSystemError file_system_error = 2;
 * @return {!proto.no.jotta.openapi.file.v2.FileSystemError}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.getFileSystemError = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.FileSystemError} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.setFileSystemError = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.clearFileSystemError = function() {
  return jspb.Message.setOneofField(this, 2, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.hasFileSystemError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RetryAfterError retry_after_error = 3;
 * @return {?proto.no.jotta.openapi.file.v2.RetryAfterError}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.getRetryAfterError = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.RetryAfterError} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.RetryAfterError, 3));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.RetryAfterError|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
*/
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.setRetryAfterError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.clearRetryAfterError = function() {
  return this.setRetryAfterError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.hasRetryAfterError = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional InvalidPathError invalid_path_error = 4;
 * @return {?proto.no.jotta.openapi.file.v2.InvalidPathError}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.getInvalidPathError = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.InvalidPathError} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.InvalidPathError, 4));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.InvalidPathError|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
*/
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.setInvalidPathError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.clearInvalidPathError = function() {
  return this.setInvalidPathError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.AllocateErrorMessage.prototype.hasInvalidPathError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string path = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional FileState state = 3;
 * @return {!proto.no.jotta.openapi.file.v2.FileState}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.getState = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.FileState} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.FileState} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string upload_id = 4;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.getUploadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.setUploadId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string upload_url = 5;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.getUploadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.setUploadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 bytes = 6;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.getBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.setBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 resume_position = 7;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.getResumePosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.AllocateResponse} returns this
 */
proto.no.jotta.openapi.file.v2.AllocateResponse.prototype.setResumePosition = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.SearchRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.SearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.SearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pathList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    pageIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.SearchRequest;
  return proto.no.jotta.openapi.file.v2.SearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.SearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPath(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageIndex(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.SearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.SearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPathList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getPageIndex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string path = 5;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.getPathList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.setPathList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.addPath = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.clearPathList = function() {
  return this.setPathList([]);
};


/**
 * optional int32 page_index = 3;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.getPageIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.setPageIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.file.v2.SearchRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.SearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.SearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.SearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    match: (f = msg.getMatch()) && proto.no.jotta.openapi.file.v2.PathItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.SearchResponse}
 */
proto.no.jotta.openapi.file.v2.SearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.SearchResponse;
  return proto.no.jotta.openapi.file.v2.SearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.SearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.SearchResponse}
 */
proto.no.jotta.openapi.file.v2.SearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.PathItem;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader);
      msg.setMatch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.SearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.SearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.SearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional PathItem match = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.SearchResponse.prototype.getMatch = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.SearchResponse} returns this
*/
proto.no.jotta.openapi.file.v2.SearchResponse.prototype.setMatch = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.SearchResponse} returns this
 */
proto.no.jotta.openapi.file.v2.SearchResponse.prototype.clearMatch = function() {
  return this.setMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.SearchResponse.prototype.hasMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.CreateFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    conflictHandler: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderRequest}
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.CreateFolderRequest;
  return proto.no.jotta.openapi.file.v2.CreateFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderRequest}
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler} */ (reader.readEnum());
      msg.setConflictHandler(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.CreateFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConflictHandler();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler = {
  UNKNOWN: 0,
  REUSE_EXISTING_FOLDER: 1,
  REJECT_CONFLICTS: 2,
  CREATE_NEW_FOLDER: 3
};

/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} returns this
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ConflictHandler conflict_handler = 2;
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler}
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.prototype.getConflictHandler = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderRequest.ConflictHandler} value
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} returns this
 */
proto.no.jotta.openapi.file.v2.CreateFolderRequest.prototype.setConflictHandler = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.CreateFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    folder: (f = msg.getFolder()) && proto.no.jotta.openapi.file.v2.PathItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderResponse}
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.CreateFolderResponse;
  return proto.no.jotta.openapi.file.v2.CreateFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderResponse}
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.PathItem;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader);
      msg.setFolder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.CreateFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.CreateFolderError = {
  UNKNOWN: 0,
  TARGET_IS_A_FILE: 1
};

/**
 * optional PathItem folder = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.prototype.getFolder = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderResponse} returns this
*/
proto.no.jotta.openapi.file.v2.CreateFolderResponse.prototype.setFolder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.CreateFolderResponse} returns this
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.prototype.clearFolder = function() {
  return this.setFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.CreateFolderResponse.prototype.hasFolder = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.MoveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.MoveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.MoveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromPath: jspb.Message.getFieldWithDefault(msg, 1, ""),
    toPath: jspb.Message.getFieldWithDefault(msg, 2, ""),
    conflictHandler: jspb.Message.getFieldWithDefault(msg, 3, 0),
    supportsBackgroundJobs: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.MoveRequest}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.MoveRequest;
  return proto.no.jotta.openapi.file.v2.MoveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.MoveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.MoveRequest}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToPath(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.MoveRequest.ConflictHandler} */ (reader.readEnum());
      msg.setConflictHandler(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsBackgroundJobs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.MoveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.MoveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.MoveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConflictHandler();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSupportsBackgroundJobs();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.ConflictHandler = {
  UNKNOWN: 0,
  REJECT_CONFLICTS: 1,
  CREATE_NEW_NAME: 2,
  CREATE_NEW_REVISION: 3
};

/**
 * optional string from_path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.getFromPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveRequest} returns this
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.setFromPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string to_path = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.getToPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveRequest} returns this
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.setToPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ConflictHandler conflict_handler = 3;
 * @return {!proto.no.jotta.openapi.file.v2.MoveRequest.ConflictHandler}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.getConflictHandler = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.MoveRequest.ConflictHandler} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.MoveRequest.ConflictHandler} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveRequest} returns this
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.setConflictHandler = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool supports_background_jobs = 4;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.getSupportsBackgroundJobs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveRequest} returns this
 */
proto.no.jotta.openapi.file.v2.MoveRequest.prototype.setSupportsBackgroundJobs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.file.v2.MoveResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  PATH_ITEM: 1,
  BACKGROUND_JOB: 2
};

/**
 * @return {proto.no.jotta.openapi.file.v2.MoveResponse.ResultCase}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.getResultCase = function() {
  return /** @type {proto.no.jotta.openapi.file.v2.MoveResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.file.v2.MoveResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.MoveResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.MoveResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.MoveResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathItem: (f = msg.getPathItem()) && proto.no.jotta.openapi.file.v2.PathItem.toObject(includeInstance, f),
    backgroundJob: (f = msg.getBackgroundJob()) && no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.MoveResponse;
  return proto.no.jotta.openapi.file.v2.MoveResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.MoveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.PathItem;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader);
      msg.setPathItem(value);
      break;
    case 2:
      var value = new no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob;
      reader.readMessage(value,no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.deserializeBinaryFromReader);
      msg.setBackgroundJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.MoveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.MoveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.MoveResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter
    );
  }
  f = message.getBackgroundJob();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveError = {
  UNKNOWN: 0,
  MOVE_FOLDER_ONTO_FILE: 1,
  MOVE_FOLDER_ONTO_FOLDER: 8,
  MOVE_FILE_ONTO_FOLDER: 2,
  MOVE_FILE_ONTO_FILE: 9,
  MOVE_BETWEEN_USERS: 3,
  MOVE_TO_FROM_ARE_EQUAL: 4,
  MOVE_FOLDER_INTO_ITSELF: 5,
  MOVE_TO_INVALID_MOUNTPOINT: 6,
  MOVE_SHARE_ONTO_SHARE: 7,
  MOVE_TO_READ_ONLY: 10
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.ErrorCase = {
  ERROR_NOT_SET: 0,
  MOVE_ERROR: 1,
  FILE_SYSTEM_ERROR: 2
};

/**
 * @return {proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.ErrorCase}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.getErrorCase = function() {
  return /** @type {proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.ErrorCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    moveError: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fileSystemError: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage;
  return proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveError} */ (reader.readEnum());
      msg.setMoveError(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (reader.readEnum());
      msg.setFileSystemError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveError} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional MoveError move_error = 1;
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveError}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.getMoveError = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveError} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveError} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.setMoveError = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.clearMoveError = function() {
  return jspb.Message.setOneofField(this, 1, proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.hasMoveError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileSystemError file_system_error = 2;
 * @return {!proto.no.jotta.openapi.file.v2.FileSystemError}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.getFileSystemError = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.FileSystemError} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.setFileSystemError = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.clearFileSystemError = function() {
  return jspb.Message.setOneofField(this, 2, proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.MoveErrorMessage.prototype.hasFileSystemError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PathItem path_item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.getPathItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse} returns this
*/
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.setPathItem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.file.v2.MoveResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse} returns this
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.clearPathItem = function() {
  return this.setPathItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.hasPathItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional no.jotta.openapi.job.v1.BackgroundJob background_job = 2;
 * @return {?proto.no.jotta.openapi.job.v1.BackgroundJob}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.getBackgroundJob = function() {
  return /** @type{?proto.no.jotta.openapi.job.v1.BackgroundJob} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob, 2));
};


/**
 * @param {?proto.no.jotta.openapi.job.v1.BackgroundJob|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse} returns this
*/
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.setBackgroundJob = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.file.v2.MoveResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.MoveResponse} returns this
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.clearBackgroundJob = function() {
  return this.setBackgroundJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.MoveResponse.prototype.hasBackgroundJob = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.CopyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.CopyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CopyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromPath: jspb.Message.getFieldWithDefault(msg, 1, ""),
    toPath: jspb.Message.getFieldWithDefault(msg, 2, ""),
    conflictHandler: jspb.Message.getFieldWithDefault(msg, 3, 0),
    supportsBackgroundJobs: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.CopyRequest}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.CopyRequest;
  return proto.no.jotta.openapi.file.v2.CopyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.CopyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.CopyRequest}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToPath(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.CopyRequest.ConflictHandler} */ (reader.readEnum());
      msg.setConflictHandler(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsBackgroundJobs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.CopyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.CopyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CopyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConflictHandler();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSupportsBackgroundJobs();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.ConflictHandler = {
  UNKNOWN: 0,
  REJECT_CONFLICTS: 1,
  CREATE_NEW_NAME: 2,
  CREATE_NEW_REVISION: 3
};

/**
 * optional string from_path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.getFromPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyRequest} returns this
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.setFromPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string to_path = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.getToPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyRequest} returns this
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.setToPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ConflictHandler conflict_handler = 3;
 * @return {!proto.no.jotta.openapi.file.v2.CopyRequest.ConflictHandler}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.getConflictHandler = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.CopyRequest.ConflictHandler} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.CopyRequest.ConflictHandler} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyRequest} returns this
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.setConflictHandler = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool supports_background_jobs = 4;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.getSupportsBackgroundJobs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyRequest} returns this
 */
proto.no.jotta.openapi.file.v2.CopyRequest.prototype.setSupportsBackgroundJobs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.file.v2.CopyResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  PATH_ITEM: 1,
  BACKGROUND_JOB: 2
};

/**
 * @return {proto.no.jotta.openapi.file.v2.CopyResponse.ResultCase}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.getResultCase = function() {
  return /** @type {proto.no.jotta.openapi.file.v2.CopyResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.file.v2.CopyResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.CopyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.CopyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CopyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathItem: (f = msg.getPathItem()) && proto.no.jotta.openapi.file.v2.PathItem.toObject(includeInstance, f),
    backgroundJob: (f = msg.getBackgroundJob()) && no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.CopyResponse;
  return proto.no.jotta.openapi.file.v2.CopyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.CopyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.PathItem;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader);
      msg.setPathItem(value);
      break;
    case 2:
      var value = new no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob;
      reader.readMessage(value,no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.deserializeBinaryFromReader);
      msg.setBackgroundJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.CopyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.CopyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CopyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter
    );
  }
  f = message.getBackgroundJob();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyError = {
  UNKNOWN: 0,
  COPY_FOLDER_ONTO_FILE: 1,
  COPY_FOLDER_ONTO_FOLDER: 7,
  COPY_FILE_ONTO_FOLDER: 2,
  COPY_FILE_ONTO_FILE: 8,
  COPY_BETWEEN_USERS: 3,
  COPY_TO_FROM_ARE_EQUAL: 4,
  COPY_FOLDER_INTO_ITSELF: 5,
  COPY_TO_INVALID_MOUNTPOINT: 6,
  COPY_TO_READ_ONLY: 9
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.ErrorCase = {
  ERROR_NOT_SET: 0,
  COPY_ERROR: 1,
  FILE_SYSTEM_ERROR: 2
};

/**
 * @return {proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.ErrorCase}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.getErrorCase = function() {
  return /** @type {proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.ErrorCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    copyError: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fileSystemError: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage;
  return proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyError} */ (reader.readEnum());
      msg.setCopyError(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (reader.readEnum());
      msg.setFileSystemError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyError} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional CopyError copy_error = 1;
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyError}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.getCopyError = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyError} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyError} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.setCopyError = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.clearCopyError = function() {
  return jspb.Message.setOneofField(this, 1, proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.hasCopyError = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileSystemError file_system_error = 2;
 * @return {!proto.no.jotta.openapi.file.v2.FileSystemError}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.getFileSystemError = function() {
  return /** @type {!proto.no.jotta.openapi.file.v2.FileSystemError} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.FileSystemError} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.setFileSystemError = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage} returns this
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.clearFileSystemError = function() {
  return jspb.Message.setOneofField(this, 2, proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.CopyErrorMessage.prototype.hasFileSystemError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PathItem path_item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.getPathItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse} returns this
*/
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.setPathItem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.file.v2.CopyResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse} returns this
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.clearPathItem = function() {
  return this.setPathItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.hasPathItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional no.jotta.openapi.job.v1.BackgroundJob background_job = 2;
 * @return {?proto.no.jotta.openapi.job.v1.BackgroundJob}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.getBackgroundJob = function() {
  return /** @type{?proto.no.jotta.openapi.job.v1.BackgroundJob} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob, 2));
};


/**
 * @param {?proto.no.jotta.openapi.job.v1.BackgroundJob|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse} returns this
*/
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.setBackgroundJob = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.file.v2.CopyResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.CopyResponse} returns this
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.clearBackgroundJob = function() {
  return this.setBackgroundJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.CopyResponse.prototype.hasBackgroundJob = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.DeleteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.DeleteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    supportsBackgroundJobs: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.DeleteRequest}
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.DeleteRequest;
  return proto.no.jotta.openapi.file.v2.DeleteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.DeleteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.DeleteRequest}
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsBackgroundJobs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.DeleteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.DeleteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSupportsBackgroundJobs();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.DeleteRequest} returns this
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool supports_background_jobs = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.prototype.getSupportsBackgroundJobs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.DeleteRequest} returns this
 */
proto.no.jotta.openapi.file.v2.DeleteRequest.prototype.setSupportsBackgroundJobs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.DeleteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.DeleteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    backgroundJob: (f = msg.getBackgroundJob()) && no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.DeleteResponse}
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.DeleteResponse;
  return proto.no.jotta.openapi.file.v2.DeleteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.DeleteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.DeleteResponse}
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob;
      reader.readMessage(value,no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.deserializeBinaryFromReader);
      msg.setBackgroundJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.DeleteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.DeleteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBackgroundJob();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.job.v1.BackgroundJob background_job = 1;
 * @return {?proto.no.jotta.openapi.job.v1.BackgroundJob}
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.prototype.getBackgroundJob = function() {
  return /** @type{?proto.no.jotta.openapi.job.v1.BackgroundJob} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob, 1));
};


/**
 * @param {?proto.no.jotta.openapi.job.v1.BackgroundJob|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.DeleteResponse} returns this
*/
proto.no.jotta.openapi.file.v2.DeleteResponse.prototype.setBackgroundJob = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.DeleteResponse} returns this
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.prototype.clearBackgroundJob = function() {
  return this.setBackgroundJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.DeleteResponse.prototype.hasBackgroundJob = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.RestoreRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.RestoreRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    supportsBackgroundJobs: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.RestoreRequest}
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.RestoreRequest;
  return proto.no.jotta.openapi.file.v2.RestoreRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.RestoreRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.RestoreRequest}
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsBackgroundJobs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.RestoreRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.RestoreRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSupportsBackgroundJobs();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.RestoreRequest} returns this
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool supports_background_jobs = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.prototype.getSupportsBackgroundJobs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.RestoreRequest} returns this
 */
proto.no.jotta.openapi.file.v2.RestoreRequest.prototype.setSupportsBackgroundJobs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.RestoreResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.RestoreResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    backgroundJob: (f = msg.getBackgroundJob()) && no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.RestoreResponse}
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.RestoreResponse;
  return proto.no.jotta.openapi.file.v2.RestoreResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.RestoreResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.RestoreResponse}
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob;
      reader.readMessage(value,no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.deserializeBinaryFromReader);
      msg.setBackgroundJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.RestoreResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.RestoreResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBackgroundJob();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.job.v1.BackgroundJob background_job = 1;
 * @return {?proto.no.jotta.openapi.job.v1.BackgroundJob}
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.prototype.getBackgroundJob = function() {
  return /** @type{?proto.no.jotta.openapi.job.v1.BackgroundJob} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob, 1));
};


/**
 * @param {?proto.no.jotta.openapi.job.v1.BackgroundJob|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.RestoreResponse} returns this
*/
proto.no.jotta.openapi.file.v2.RestoreResponse.prototype.setBackgroundJob = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.RestoreResponse} returns this
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.prototype.clearBackgroundJob = function() {
  return this.setBackgroundJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.RestoreResponse.prototype.hasBackgroundJob = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    supportsBackgroundJobs: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest;
  return proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsBackgroundJobs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSupportsBackgroundJobs();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} returns this
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool supports_background_jobs = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.prototype.getSupportsBackgroundJobs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} returns this
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest.prototype.setSupportsBackgroundJobs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    backgroundJob: (f = msg.getBackgroundJob()) && no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse;
  return proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob;
      reader.readMessage(value,no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.deserializeBinaryFromReader);
      msg.setBackgroundJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBackgroundJob();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.job.v1.BackgroundJob background_job = 1;
 * @return {?proto.no.jotta.openapi.job.v1.BackgroundJob}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.prototype.getBackgroundJob = function() {
  return /** @type{?proto.no.jotta.openapi.job.v1.BackgroundJob} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_job_v1_job_v1_pb.BackgroundJob, 1));
};


/**
 * @param {?proto.no.jotta.openapi.job.v1.BackgroundJob|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse} returns this
*/
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.prototype.setBackgroundJob = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse} returns this
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.prototype.clearBackgroundJob = function() {
  return this.setBackgroundJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.prototype.hasBackgroundJob = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListRevisionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListRevisionsRequest;
  return proto.no.jotta.openapi.file.v2.ListRevisionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListRevisionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest} returns this
 */
proto.no.jotta.openapi.file.v2.ListRevisionsRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListRevisionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    revisionsList: jspb.Message.toObjectList(msg.getRevisionsList(),
    proto.no.jotta.openapi.file.v2.FileRevision.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListRevisionsResponse}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListRevisionsResponse;
  return proto.no.jotta.openapi.file.v2.ListRevisionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListRevisionsResponse}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.FileRevision;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.FileRevision.deserializeBinaryFromReader);
      msg.addRevisions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListRevisionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRevisionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.FileRevision.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FileRevision revisions = 1;
 * @return {!Array<!proto.no.jotta.openapi.file.v2.FileRevision>}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.prototype.getRevisionsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.file.v2.FileRevision>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.file.v2.FileRevision, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.file.v2.FileRevision>} value
 * @return {!proto.no.jotta.openapi.file.v2.ListRevisionsResponse} returns this
*/
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.prototype.setRevisionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.FileRevision=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.FileRevision}
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.prototype.addRevisions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.file.v2.FileRevision, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.ListRevisionsResponse} returns this
 */
proto.no.jotta.openapi.file.v2.ListRevisionsResponse.prototype.clearRevisionsList = function() {
  return this.setRevisionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.SimpleFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.SimpleFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SimpleFile.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    path: jspb.Message.getFieldWithDefault(msg, 2, ""),
    checksum: jspb.Message.getFieldWithDefault(msg, 3, ""),
    modifiedAtMillis: jspb.Message.getFieldWithDefault(msg, 4, 0),
    deletedAtMillis: jspb.Message.getFieldWithDefault(msg, 5, 0),
    size: jspb.Message.getFieldWithDefault(msg, 6, 0),
    owner: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.SimpleFile;
  return proto.no.jotta.openapi.file.v2.SimpleFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.SimpleFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setModifiedAtMillis(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeletedAtMillis(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.SimpleFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.SimpleFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SimpleFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModifiedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDeletedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getOwner();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string path = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string checksum = 3;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 modified_at_millis = 4;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.getModifiedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.setModifiedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 deleted_at_millis = 5;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.getDeletedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.setDeletedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 size = 6;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string owner = 7;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.getOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFile} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFile.prototype.setOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.file.v2.Item.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.Item.ItemCase = {
  ITEM_NOT_SET: 0,
  FOLDER: 1,
  FILE: 2
};

/**
 * @return {proto.no.jotta.openapi.file.v2.Item.ItemCase}
 */
proto.no.jotta.openapi.file.v2.Item.prototype.getItemCase = function() {
  return /** @type {proto.no.jotta.openapi.file.v2.Item.ItemCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.file.v2.Item.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    folder: (f = msg.getFolder()) && proto.no.jotta.openapi.file.v2.SimpleFolder.toObject(includeInstance, f),
    file: (f = msg.getFile()) && proto.no.jotta.openapi.file.v2.SimpleFile.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.Item}
 */
proto.no.jotta.openapi.file.v2.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.Item;
  return proto.no.jotta.openapi.file.v2.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.Item}
 */
proto.no.jotta.openapi.file.v2.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.SimpleFolder;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.SimpleFolder.deserializeBinaryFromReader);
      msg.setFolder(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.file.v2.SimpleFile;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.SimpleFile.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.SimpleFolder.serializeBinaryToWriter
    );
  }
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.file.v2.SimpleFile.serializeBinaryToWriter
    );
  }
};


/**
 * optional SimpleFolder folder = 1;
 * @return {?proto.no.jotta.openapi.file.v2.SimpleFolder}
 */
proto.no.jotta.openapi.file.v2.Item.prototype.getFolder = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.SimpleFolder} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.SimpleFolder, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.SimpleFolder|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.Item} returns this
*/
proto.no.jotta.openapi.file.v2.Item.prototype.setFolder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.file.v2.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.Item} returns this
 */
proto.no.jotta.openapi.file.v2.Item.prototype.clearFolder = function() {
  return this.setFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.Item.prototype.hasFolder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SimpleFile file = 2;
 * @return {?proto.no.jotta.openapi.file.v2.SimpleFile}
 */
proto.no.jotta.openapi.file.v2.Item.prototype.getFile = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.SimpleFile} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.SimpleFile, 2));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.SimpleFile|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.Item} returns this
*/
proto.no.jotta.openapi.file.v2.Item.prototype.setFile = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.file.v2.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.Item} returns this
 */
proto.no.jotta.openapi.file.v2.Item.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.Item.prototype.hasFile = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.SimpleFolder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.SimpleFolder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    path: jspb.Message.getFieldWithDefault(msg, 2, ""),
    deletedAtMillis: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFolder}
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.SimpleFolder;
  return proto.no.jotta.openapi.file.v2.SimpleFolder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.SimpleFolder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFolder}
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeletedAtMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.SimpleFolder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.SimpleFolder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeletedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFolder} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string path = 2;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFolder} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 deleted_at_millis = 3;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.getDeletedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.SimpleFolder} returns this
 */
proto.no.jotta.openapi.file.v2.SimpleFolder.prototype.setDeletedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListFolderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    includeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderRequest}
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListFolderRequest;
  return proto.no.jotta.openapi.file.v2.ListFolderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderRequest}
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListFolderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIncludeDeleted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderRequest} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool include_deleted = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.prototype.getIncludeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderRequest} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderRequest.prototype.setIncludeDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListFolderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    folder: (f = msg.getFolder()) && proto.no.jotta.openapi.file.v2.SimpleFolder.toObject(includeInstance, f),
    childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.no.jotta.openapi.file.v2.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderResponse}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListFolderResponse;
  return proto.no.jotta.openapi.file.v2.ListFolderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderResponse}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.SimpleFolder;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.SimpleFolder.deserializeBinaryFromReader);
      msg.setFolder(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.file.v2.Item;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.Item.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListFolderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.SimpleFolder.serializeBinaryToWriter
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.no.jotta.openapi.file.v2.Item.serializeBinaryToWriter
    );
  }
};


/**
 * optional SimpleFolder folder = 1;
 * @return {?proto.no.jotta.openapi.file.v2.SimpleFolder}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.getFolder = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.SimpleFolder} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.SimpleFolder, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.SimpleFolder|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderResponse} returns this
*/
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.setFolder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderResponse} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.clearFolder = function() {
  return this.setFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.hasFolder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Item children = 2;
 * @return {!Array<!proto.no.jotta.openapi.file.v2.Item>}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.file.v2.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.file.v2.Item, 2));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.file.v2.Item>} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderResponse} returns this
*/
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.Item}
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.no.jotta.openapi.file.v2.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderResponse} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderResponse.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListFolderItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && proto.no.jotta.openapi.file.v2.Item.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemResponse}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListFolderItemResponse;
  return proto.no.jotta.openapi.file.v2.ListFolderItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemResponse}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.Item;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.Item.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListFolderItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.Item.serializeBinaryToWriter
    );
  }
};


/**
 * optional Item item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.Item}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.prototype.getItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.Item} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.Item, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.Item|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemResponse} returns this
*/
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemResponse} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemResponse.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListFolderStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    folderCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fileCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStats}
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListFolderStats;
  return proto.no.jotta.openapi.file.v2.ListFolderStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStats}
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFolderCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFileCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListFolderStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFileCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 folder_count = 1;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.prototype.getFolderCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStats} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.prototype.setFolderCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 file_count = 2;
 * @return {number}
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.prototype.getFileCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStats} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderStats.prototype.setFileCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  ITEM: 1,
  STATS: 2
};

/**
 * @return {proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.ResultCase}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.getResultCase = function() {
  return /** @type {proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && proto.no.jotta.openapi.file.v2.Item.toObject(includeInstance, f),
    stats: (f = msg.getStats()) && proto.no.jotta.openapi.file.v2.ListFolderStats.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse;
  return proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.Item;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.Item.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.file.v2.ListFolderStats;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.ListFolderStats.deserializeBinaryFromReader);
      msg.setStats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.Item.serializeBinaryToWriter
    );
  }
  f = message.getStats();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.file.v2.ListFolderStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional Item item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.Item}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.getItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.Item} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.Item, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.Item|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse} returns this
*/
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.setItem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ListFolderStats stats = 2;
 * @return {?proto.no.jotta.openapi.file.v2.ListFolderStats}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.getStats = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.ListFolderStats} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.file.v2.ListFolderStats, 2));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.ListFolderStats|undefined} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse} returns this
*/
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.setStats = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.clearStats = function() {
  return this.setStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.prototype.hasStats = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    recursive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    includeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest}
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.ListFolderStreamRequest;
  return proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest}
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecursive(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecursive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIncludeDeleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool recursive = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.getRecursive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.setRecursive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool include_deleted = 3;
 * @return {boolean}
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.getIncludeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} returns this
 */
proto.no.jotta.openapi.file.v2.ListFolderStreamRequest.prototype.setIncludeDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.RecentFilesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.RecentFilesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RecentFilesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.RecentFilesRequest}
 */
proto.no.jotta.openapi.file.v2.RecentFilesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.RecentFilesRequest;
  return proto.no.jotta.openapi.file.v2.RecentFilesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.RecentFilesRequest}
 */
proto.no.jotta.openapi.file.v2.RecentFilesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.RecentFilesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.RecentFilesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RecentFilesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.file.v2.RecentFilesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.no.jotta.openapi.file.v2.PathItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.file.v2.RecentFilesResponse}
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.file.v2.RecentFilesResponse;
  return proto.no.jotta.openapi.file.v2.RecentFilesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.file.v2.RecentFilesResponse}
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.file.v2.PathItem;
      reader.readMessage(value,proto.no.jotta.openapi.file.v2.PathItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.file.v2.RecentFilesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.file.v2.PathItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PathItem items = 1;
 * @return {!Array<!proto.no.jotta.openapi.file.v2.PathItem>}
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.file.v2.PathItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.file.v2.PathItem, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.file.v2.PathItem>} value
 * @return {!proto.no.jotta.openapi.file.v2.RecentFilesResponse} returns this
*/
proto.no.jotta.openapi.file.v2.RecentFilesResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.PathItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.file.v2.PathItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.file.v2.RecentFilesResponse} returns this
 */
proto.no.jotta.openapi.file.v2.RecentFilesResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.ItemType = {
  UNKNOWN_ITEM_TYPE: 0,
  FILE: 1,
  FOLDER: 2
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.ItemKind = {
  UNKNOWN_ITEM_KIND: 0,
  OTHER: 1,
  MODULE: 2,
  REGULAR_FOLDER: 3,
  VIDEO: 4,
  AUDIO: 5,
  IMAGE: 6,
  TEXT: 7,
  PDF: 8,
  RICH_TEXT: 9,
  DOCUMENT: 26,
  WORD: 27,
  SPREADSHEET: 10,
  EXCEL: 28,
  PRESENTATION: 11,
  POWERPOINT: 29,
  HTML: 12,
  ARCHIVE_KIND: 13,
  COLLABORATION_FOLDER: 14,
  WORKSTATION: 15,
  LAPTOP: 16,
  MACBOOK: 17,
  IMAC: 18,
  MACPRO: 19,
  IPHONE: 20,
  IPAD: 21,
  ANDROID: 22,
  WINDOWS_PHONE: 23,
  WINDOWS_TABLET: 24,
  CLI: 25
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.ItemAction = {
  UNKNOWN_FILE_ACTION: 0,
  ADD_CHILD: 1,
  COPY: 2,
  MOVE: 3,
  DELETE: 4,
  RESTORE: 5,
  PERMANENTLY_DELETE: 6,
  PUBLIC_SHARE: 7,
  PUBLIC_UNSHARE: 8,
  UPDATE: 9
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.FileState = {
  UNKNOWN_FILE_STATE: 0,
  ADDED: 1,
  INCOMPLETE: 2,
  CORRUPT: 3,
  PROCESSING: 4,
  COMPLETED: 5
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.AllocateConflictHandler = {
  REJECT_CONFLICTS: 0,
  CREATE_NEW_REVISION: 1,
  CREATE_NEW_FILE: 2
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.file.v2.FileSystemError = {
  UNKNOWN_FILE_SYSTEM_ERROR: 0,
  READ_LOCKED: 1,
  WRITE_LOCKED: 2,
  INSUFFICIENT_CAPACITY: 3
};

goog.object.extend(exports, proto.no.jotta.openapi.file.v2);
